import { Injectable } from '@angular/core';

import { Observable, tap } from 'rxjs';

import { LiveCasinoGamesModel, LiveEventListService } from './live-event-list.service';

@Injectable({ providedIn: 'root' })
export class LiveCasinoResolver {
    constructor(private liveEventListService: LiveEventListService) {}

    resolve(): Observable<LiveCasinoGamesModel | undefined> {
        return this.liveEventListService.getLiveCasinoGames().pipe(tap((model) => this.liveEventListService.notifyParent(model)));
    }

    preResolve() {
        this.liveEventListService.getLiveCasinoGames().pipe();
    }
}
